import { useCallback, useEffect, useState } from 'react';
import Axios from '../api/axios';
import * as glb from '../globals';
import { publishBandCount } from '../utils/browserBandNotification';

export function useCariTarihBildirim() {
  const [data, setData] = useState({ sayi: 0, list: [] });
  const refresh = useCallback(async () => {
    const kulid = Number(glb.default?.KULLANICI?.KUL_REF || 0);
    if (!kulid) return;
    try {
      const response = await Axios.get(
        `${process.env.REACT_APP_BACKEND_SERVER}cari_tarih_bildirim/liste`,
        { params: { kulid } },
      );
      const sayi = Number(response.data?.sayi) || 0;
      setData({
        sayi,
        list: Array.isArray(response.data?.list) ? response.data.list : [],
      });
      publishBandCount('tarih', sayi, {
        title: 'Tarih',
        body: sayi === 1
          ? '1 randevu veya ileri tarih hatırlatması var'
          : `${sayi} randevu veya ileri tarih hatırlatması var`,
      });
    } catch (_) { /* sonraki periyotta tekrar denenecek */ }
  }, []);

  useEffect(() => {
    refresh();
    const timer = setInterval(refresh, 60_000);
    window.addEventListener('focus', refresh);
    return () => {
      clearInterval(timer);
      window.removeEventListener('focus', refresh);
    };
  }, [refresh]);

  return { ...data, refresh };
}
